import { z } from 'zod';
import { dateToUTC } from 'shared/src/utils/zod/zod-utils';

const JoinOperator = z.union([z.literal('AND'), z.literal('OR')]);

export const AgDateSimpleFilter = z.object({
  dateFrom: dateToUTC.nullable(),
  dateTo: dateToUTC.nullable(),
  filterType: z.literal('date'),
  type: z.union([
    z.literal('equals'),
    z.literal('lessThan'),
    z.literal('greaterThan'),
    z.literal('inRange')
  ])
});
export type AgDateSimpleFilter = z.infer<typeof AgDateSimpleFilter>;

export const AgDateCompoundFilter = z.object({
  filterType: z.literal('date'),
  operator: JoinOperator,
  conditions: z
    .array(AgDateSimpleFilter.extend({ filterType: z.literal('date').optional() }))
    .min(1)
});
export type AgDateCompoundFilter = z.infer<typeof AgDateCompoundFilter>;

export const AgDateFilter = z.union([AgDateSimpleFilter, AgDateCompoundFilter]);
export type AgDateFilter = z.infer<typeof AgDateFilter>;

export const AgDateStringFilter = AgDateSimpleFilter.extend({
  dateFrom: z.string().nullable(),
  dateTo: z.string().nullable()
});
export type AgDateStringFilter = z.infer<typeof AgDateStringFilter>;

export const AgNumberSimpleFilter = z.object({
  filter: z.number().optional(),
  filterTo: z.number().optional(),
  filterType: z.literal('number'),
  type: z.union([
    z.literal('equals'),
    z.literal('greaterThan'),
    z.literal('greaterThanOrEqual'),
    z.literal('lessThan'),
    z.literal('lessThanOrEqual'),
    z.literal('inRange')
  ])
});
export type AgNumberSimpleFilter = z.infer<typeof AgNumberSimpleFilter>;

export const AgNumberCompoundFilter = z.object({
  filterType: z.literal('number'),
  operator: JoinOperator,
  conditions: z
    .array(AgNumberSimpleFilter.extend({ filterType: z.literal('number').optional() }))
    .min(1)
});
export type AgNumberCompoundFilter = z.infer<typeof AgNumberCompoundFilter>;

export const AgNumberFilter = z.union([AgNumberSimpleFilter, AgNumberCompoundFilter]);
export type AgNumberFilter = z.infer<typeof AgNumberFilter>;

export const AgSetFilter = z.object({
  filterType: z.literal('set'),
  values: z.array(z.union([z.string(), z.number()]))
});
export type AgSetFilter = z.infer<typeof AgSetFilter>;

export const AgTextSimpleFilter = z.object({
  filterType: z.literal('text'),
  type: z.union([z.literal('contains'), z.literal('notContains')]),
  filter: z.string().optional()
});
export type AgTextSimpleFilter = z.infer<typeof AgTextSimpleFilter>;

export const AgTextCompoundFilter = z.object({
  filterType: z.literal('text'),
  operator: JoinOperator,
  conditions: z
    .array(AgTextSimpleFilter.extend({ filterType: z.literal('text').optional() }))
    .min(1)
});
export type AgTextCompoundFilter = z.infer<typeof AgTextCompoundFilter>;

export const AgTextFilter = z.union([AgTextSimpleFilter, AgTextCompoundFilter]);
export type AgTextFilter = z.infer<typeof AgTextFilter>;
